import {
  VacanciesType,
  ParsedVacancy,
  MapedVacanciesType,
  VacanciesFeedbackType,
} from './utils';

export enum VacanciesStatusEnum {
  GET_EVENT_VACANCIES = 'vacancies/get',
  GET_EVENT_VACANCY = 'vacancy/get',
  GET_VACANCY_ORDERS = 'vacancy-orders/get',
  POST_VACANCY_ORDERS_CREATE = 'vacancy-order/create',
  GET_INVITATIONS = 'portfolio-interviews/get',
}

export interface GetVacancies {
  data: VacanciesType;
}

export interface GetFeedbacks {
  data: VacanciesFeedbackType;
}

export interface PromiseVacancies {
  data: MapedVacanciesType;
  filtered?: number;
}

export interface PromiseVacancy {
  data: ParsedVacancy;
}
export interface Payload {
  vacancy_id: string;
  cover_letter: string;
  resume_file: File;
}

export const ordersCancelUrl = (id: string): string =>
  `vacancy-orders/${id}/cancel`;



// WEBPACK FOOTER //
// ./src/services/api/vacancies/types.ts